import React, { Component } from "react";

class OmnidoxAlert extends Component {
  render() {
    return (
      <div className={"omnidox-alert " + (this.props.Type || "success")}>
        <span className="omnidox-alert-icon-wrapper">
          <i className={"icon icon-" + (this.props.Icon || "check")} />
        </span>
        <span className="message">{this.props.children || "Notification Here"}</span>
      </div>
    );
  }
}

export default OmnidoxAlert;
